module.exports = __webpack_public_path__ + "img/intro_pc_img02.c59e9f9a.png";